import React from 'react';
import VerifyAccount from '../../@jumbo/components/Common/authComponents/VerifyAccount';

const VerifyAccountFunction = () => <VerifyAccount variant="standard" wrapperVariant="bgColor" />;

export default VerifyAccountFunction;
